import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=f700fa0e&scoped=true"
import script from "./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Alert.vue?vue&type=style&index=0&id=f700fa0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f700fa0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonPrimary: require('/app/apps/admin/components/button/ButtonPrimary.vue').default})
